<template>
  <div id="image-form">
    <form class="form" @submit.prevent="submitForm" ref="imageForm" autocomplete="off">
      <div class="form-group">
        <label for="gateName">Related gate</label>
        <select v-model="form.gateName" id="gateName" ref="gateField">
          <option disabled value="">Please select the Gate</option>
          <option>Blue</option>
          <option>Emerald</option>
          <option>Green</option>
          <option>Indigo</option>
          <option>Orange</option>
          <option>Red</option>
          <option>Turquoise</option>
          <option>Violet</option>
          <option>Woad</option>
          <option>Yellow</option>
          <option>Other</option>
        </select>
      </div>
      <div class="form-group">
        <label for="imageShared">Upload an image</label>
        <input type="file" id="imageShared" ref="imageShared" @change="handleFileUpload" />
      </div>
      <div class="form-group">
        <label for="imageComment">Share your message</label>
        <textarea v-model="form.comment" placeholder="Your text" id="imageComment" />
      </div>
      <div>
        <button>Submit</button>
      </div>
    </form>
    <p v-if="submissionFeedback">{{ submissionFeedback }}</p>
  </div>
</template>


<script>
import {apiService, apiServiceImage} from "@/common/api.service";

export default {
  name: "PostContent",
  data() {
    return {
      form: {
        gateName: null,
        imageFile: null,
        comment: null,
      },
      submissionFeedback: null,
      postEndpoint: 'https://api.greenhamwomen.digital/plenum/contribution/',
    }
  },
  methods: {
    handleFileUpload(e) {
      let fileName = e.target.files[0].name
      if ((/\.(gif|jpe?g|png|webp|bmp)$/i).test(fileName)) {
        this.form.imageFile = e.target.files[0];
        this.submissionFeedback = null
      } else {
        this.submissionFeedback = "Wrong file format, please upload an image, field cleared."
        this.$refs.imageShared.value = "";
      }
    },

    submitForm() {
      if (!this.form.gateName) {
        this.submissionFeedback = "Please select the gate name."
      } else if (!this.form.comment) {
        this.submissionFeedback = "Please add your comment before posting."
      } else if (this.form.comment > 360) {
        this.submissionFeedback = "Please keep your comment as concise as possible, no more than 350 characters."
      } else if (!this.form.imageFile) {

        this.postTextOnly(this.postEndpoint, "POST")
      } else {
        this.postWithImage(this.postEndpoint, "POST")
      }
    },

    postTextOnly(endpoint, method) {
      let data = {
        "gate_name": this.form.gateName,
        "comment": this.form.comment
      }
      apiService(endpoint, method, data).
      then(() => this.clearFormData())

    },

    postWithImage: function (endpoint, method) {
      let data = new FormData()
      data.append("gate_name", this.form.gateName)
      data.append("file", this.form.imageFile)
      data.append("comment", this.form.comment)
      apiServiceImage(endpoint, method, data).
      then(() => this.clearFormData())

    },

    clearFormData() {
      this.submissionFeedback = "Thank you for sharing your memories of the peace camps. Submission are reviewed and added to the site regularly."
      this.form.gateName = ""
      this.$refs.imageShared.value = "";
      this.form.comment = ""
    }
  }
}


</script>

<style scoped>

#image-form {
    padding-bottom: 5em;
}

</style>
